<div class="parent-modal">
  <div class="stepper-shell">
    <div class="stepper-sidebar">
      <a class="stepper-sidebar__back mwc-text-sm-medium mwc-color-primary-700" (click)="closeModal()" *ngIf="!hideChangeWorkflow">
        <span mwc-icon mwcIconfont="arrow-left" style="font-size: 15px;"></span>Back to Change Template
      </a>
      <div class="stepper-sidebar__title mwc-text-xl-semibold mwc-color-gray-900">{{selectedTemplateTitle}}</div>
      <div class="stepper-progress">
        <div *ngFor="let tab of tabs" class="stepper-progress__segment" [ngClass]="{'stepper-progress__segment--filled': tab.index <= selectedIndex}"></div>
      </div>
      <div class="stepper-progress__meta">
        <span class="mwc-text-xs-medium mwc-color-gray-600">Progress</span>
        <span class="mwc-text-xs-medium mwc-color-primary-700">{{ tabs.length ? (((selectedIndex + 1) / tabs.length) * 100 | number:'1.0-0') : 0 }}%</span>
      </div>
      <div class="stepper-steps">
        <div *ngFor="let tab of tabs" class="stepper-step"
             [ngClass]="{'stepper-step--active': tab.index == selectedIndex, 'stepper-step--completed': tab.index < selectedIndex, 'stepper-step--disabled': isTabDisabled(tab)}"
             (click)="selectStep(tab)">
          <div class="stepper-step__icon">
            <span mwc-icon [mwcIconfont]="tab.index < selectedIndex ? 'check-circle' : tab.iconName" style="font-size: 18px;"></span>
          </div>
          <div class="stepper-step__text">
            <div class="mwc-text-sm-medium" [ngClass]="tab.index == selectedIndex ? 'mwc-color-primary-700' : 'mwc-color-gray-900'">{{customTemplates && tab.name=='Topic Details'?'Page Details':tab.name}}</div>
            <div class="mwc-text-xs-regular mwc-color-gray-500" *ngIf="stepSubtitles[tab.name]">{{stepSubtitles[tab.name]}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="stepper-main">
  <form mwc-form [formGroup]="generateAiForm" class="generateAiForm">
    <mwc-tabset [mwcTabPosition]="'left'"
                [(mwcSelectedIndex)]="selectedIndex"
                (mwcSelectChange)="tabsSetSelectChange([$event])">
      <ng-container *ngFor="let tab of tabs">
        <mwc-tab [mwcTitle]="titleTemplate"
                 (mwcClick)="tabSelectChange(['click', tab])" [mwcDisabled]="isTabDisabled(tab)">
          <ng-template #titleTemplate>
            <div class="d-flex align-items-center">
              <span mwc-icon [mwcIconfont]="tab.iconName" style="font-size: 20px;"></span>
              <span class="mwc-text-sm-medium" style="width: 130px;text-align: left;">{{customTemplates && tab.name=='Topic Details'?'Page Details':tab.name}}</span>
              <span mwc-icon [mwcIconfont]="'check-circle'" style="font-size: 18px;margin: 0;" class="check-icon" [ngClass]="{'completed' : tab.index < selectedIndex }"></span>
            </div>
          </ng-template>
          <div style="height: 100%;">
            <!--Context Analysis-->
            <ng-container *ngIf="tab.name == 'Analysis' || tab.name=='Creation Flow'">
              <div class="mwc-text-lg-medium mb-3">{{tab.name}}</div>
              <ng-container *ngIf="!contentAnalysis">
                <mwc-radio-group *ngIf="generateFaqsFromExistingContent" class="context-source-tabs"
                                 [(ngModel)]="contextSourceTab" [ngModelOptions]="{standalone: true}"
                                 (ngModelChange)="contextSourceTabChange($event)">
                  <label mwc-radio-button mwcValue="url">
                    <span class="d-flex align-items-center gap-2">
                      <span mwc-icon style="font-size: 16px;" [mwcIconfont]="'link-01'"></span>
                      Provide URL
                    </span>
                  </label>
                  <label mwc-radio-button mwcValue="upload">
                    <span class="d-flex align-items-center gap-2">
                      <span mwc-icon style="font-size: 16px;" [mwcIconfont]="'upload-01'"></span>
                      Upload Document
                      </span>
                  </label>
                  <label mwc-radio-button mwcValue="text">
                    <span class="d-flex align-items-center gap-2">
                      <span mwc-icon style="font-size: 16px;" [mwcIconfont]="'file-06'"></span>
                      Paste Text
                      </span>
                  </label>
                </mwc-radio-group>
                <mwc-form-item class="form-item-sec" *ngIf="showUrlInput">
                  <mwc-form-label [mwcSpan]="24">{{customTemplates?'Refresh Existing Page from this URL':'Provide URL'}}</mwc-form-label>
                  <mwc-form-control [mwcSpan]="24" [mwcErrorTip]="urlError">
                    <mwc-input-group [mwcSuffix]="suffixTemplateInfo">
                      <input mwc-input formControlName="contextUrl" placeholder="Type your URL here" class="mwc-text-sm-regular" mwcSize="small" (input)="showUrl()" />
                    </mwc-input-group>
                    <ng-template #suffixTemplateInfo>
                      <mwc-spin [mwcIndicator]="customSpinTpl" *ngIf="contextUrlControl.pending" mwcSize="default"></mwc-spin>
                    </ng-template>
                    <ng-template #urlError let-control>
                      <div *ngIf="control?.hasError('emptyUrl')">
                        This field can’t be empty.
                      </div>
                      <div *ngIf="control?.hasError('invalidUrl') || control?.hasError('nonHtmlResource')">
                        Enter a valid URL (for example: https://example.com).
                      </div>
                      <div *ngIf="control?.hasError('urlTooLong')">
                        Shorten the URL and try again.
                      </div>
                      <div *ngIf="control?.hasError('pageNotFound')">
                        Page not found. The URL doesn’t point to an existing page.
                      </div>
                      <div *ngIf="control?.hasError('accessRestricted')">
                        Access restricted. This page isn’t publicly accessible.
                      </div>
                      <div *ngIf="control?.hasError('timeout')">
                        Website unreachable. The application took too long to respond.
                      </div>
                      <div *ngIf="control?.hasError('genericError')">
                        Unable to access the URL. Please verify the link and try again.
                      </div>
                      <div *ngIf="
                          control?.invalid &&
                          control?.touched &&
                          !control?.errors?.emptyUrl &&
                          !control?.errors?.invalidUrl &&
                          !control?.errors?.nonHtmlResource &&
                          !control?.errors?.urlTooLong &&
                          !control?.errors?.pageNotFound &&
                          !control?.errors?.accessRestricted &&
                          !control?.errors?.timeout &&
                          !control?.errors?.genericError
                        ">
                        {{ youtubeSummaryContent ? 'Please use a valid YouTube URL' : 'URL is invalid' }}
                      </div>
                    </ng-template>
                  </mwc-form-control>
                </mwc-form-item>
                <div style="position: relative;" *ngIf="!generateFaqsFromExistingContent && ((isUploadVisible && isUrlVisible) || customTemplates)">
                  <mwc-divider style="margin: 36px 0;"></mwc-divider>
                  <button mwc-button mwcType="default" mwcSize="small" class="or-btn">OR</button>
                </div>
                <mwc-form-item class="form-item-sec" *ngIf="customTemplates">
                  <a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style=" display: flex; align-items: center; justify-content: flex-start; " (click)="processAction()"> <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>Create New Page</a>
                </mwc-form-item>
                <mwc-form-item class="form-item-sec" *ngIf="showUploadInput">
                  <mwc-form-label [mwcSpan]="24">Upload Document</mwc-form-label>
                  <mwc-form-control [mwcSpan]="24">
                    <div style="display: flex;flex-direction: column;" class="bulk-upload">
                      <ng-container>
                        <mwc-upload mwcType="drag" [mwcMultiple]="false" mwcAccept=".txt, .pdf, .doc, .docx, .htm, .html" (mwcChange)="handleChange($event)" [(mwcFileList)]="fileList" [mwcHint]="'TXT, PDF, DOC, DOCX, HTM, HTML'" [mwcIconRender]="renderTemplate" [mwcBeforeUpload]="beforeUpload">
                          <ng-template #renderTemplate>
                            <span mwc-icon style="font-size: 16px;" [mwcIconfont]="(fileList[0] && (fileList[0].percent >= 100 || fileList[0].status == 'done' )? 'check-circle':'file-04')"></span>
                          </ng-template>
                        </mwc-upload>
                      </ng-container>
                    </div>
                  </mwc-form-control>
                </mwc-form-item>
                <mwc-form-item class="form-item-sec" *ngIf="showTextInput">
                  <mwc-form-label [mwcSpan]="24">Paste Text</mwc-form-label>
                  <mwc-form-control [mwcSpan]="24">
                    <textarea mwc-input formControlName="contextText" rows="8" class="mwc-text-sm-regular"
                              placeholder="Paste text here..." (input)="onContextTextChange()"></textarea>
                    <div class="context-text-count mwc-text-xs-regular" [class.over-limit]="isContextTextOverLimit">
                      {{contextTextWordCount}}/{{contextTextMaxWords}}
                    </div>
                  </mwc-form-control>
                </mwc-form-item>
                <ng-container *ngIf="isUploadVisible && !isUrlVisible && !customTemplates && !generateFaqsFromExistingContent">
                  <div class="mwc-text-sm-medium my-2">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: none;" (click)="showUrl()"><span class="mwc-color-primary-700 mwc-text-sm-regular">proceed with an URL</span></a> instead?</div>
                </ng-container>
                <ng-container *ngIf="isUrlVisible && !isUploadVisible && !customTemplates && !youtubeSummaryContent && !generateFaqsFromExistingContent">
                  <div class="mwc-text-sm-medium my-2">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: none;" (click)="showUpload()"><span class="mwc-color-primary-700 mwc-text-sm-regular">upload a document</span></a> instead?</div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="contentAnalysis">
                <div class="upload-progress-sec">
                  <div *ngIf="contentAnalysisStatus == 'analyzing'">
                    <div class="py-0 loader-img"><img src="assets/images/stars-gif.gif" alt="" /></div>
                    <div class="mwc-text-xl-regular mwc-color-gray-900">
                      {{
 isFileAnalysis ? 'Analyzing the File' : 'Analyzing the URL'
                      }}
                    </div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Give us a moment to analyze and generate the data.</div>
                  </div>
                  <div *ngIf="contentAnalysisStatus == 'error'">
                    <div><mwc-avatar mwcIcon="announcement-02" class="avatar-icon"></mwc-avatar></div>
                    <div class="mwc-text-xl-regular mwc-color-gray-900">Oops.. something went wrong</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Looks like there was a problem crawling <br /> the content on this page. Please <a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1 mwc-text-sm-regular" style="text-decoration: underline;" (click)="tryAgain()"><span class="mwc-color-primary-700">try again.</span></a></div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <!--Upload URLs-->
            <ng-container *ngIf="tab.name == 'Upload URLs'">
              <div class="upload-urls-header">Upload URLs</div>
              <ng-container *ngIf="bulkUploadAnalysis">
                <div class="upload-progress-sec">
                  <div *ngIf="bulkUploadAnalysisStatus == 'analyzing'">
                    <div class="py-0 loader-img"><img src="assets/images/stars-gif.gif" alt="" /></div>
                    <div class="mwc-text-xl-regular mwc-color-gray-900">Analyzing the URL</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Give us a moment to analyze and generate the data.</div>
                  </div>
                  <div *ngIf="bulkUploadAnalysisStatus == 'error'">
                    <div><mwc-avatar mwcIcon="announcement-02" class="avatar-icon"></mwc-avatar></div>
                    <div class="mwc-text-xl-regular mwc-color-gray-900">Oops.. something went wrong</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Looks like there was a problem crawling <br /> the content on this page. Please <a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1 mwc-text-sm-regular" style="text-decoration: underline;"><span class="mwc-color-primary-700">try again.</span></a></div>
                  </div>
                </div>
              </ng-container>
              <div class="upload-urls-form" *ngIf="!bulkUploadAnalysis">
                <!-- <ng-container class="parent-urls" *ngIf="isParentUrlVisible">
                  <mwc-form-item class="upload-urls-form-item m-0">
                    <mwc-form-label [mwcSpan]="24" class="upload-urls-label">Provide Website/Parent URL</mwc-form-label>
                    <mwc-form-control [mwcSpan]="24" [mwcErrorTip]="websiteParentUrlError">
                      <input mwc-input
                             formControlName="websiteParentUrl"
                             placeholder="Enter URL"
                             class="upload-urls-input"
                             mwcSize="small" (input)="parentUrlChange()"/>
                    </mwc-form-control>
                    <ng-template #websiteParentUrlError let-control>
                      <ng-container *ngIf="generateAiForm.controls.websiteParentUrl.invalid">
                        {{'Url is invalid'}}
                      </ng-container>
                    </ng-template>
                  </mwc-form-item>
                </ng-container>

                <div class="upload-urls-separator py-4 my-2" *ngIf="isParentUrlVisible && isIndividualUrlVisible">
                  <div class="upload-urls-divider"></div>
                  <div class="upload-urls-or-button">OR</div>
                </div> -->
                <ng-container class="individual-urls" *ngIf="isIndividualUrlVisible">
                  <mwc-form-item class="upload-urls-form-item upload-urls-textarea-item">
                    <mwc-form-label [mwcSpan]="24" class="upload-urls-label">
                      Provide individual URLs <span class="upload-urls-limit">(Max limit: 300)</span>
                    </mwc-form-label>
                    <mwc-form-control [mwcSpan]="24" [mwcErrorTip]="individualUrlsError">
                      <textarea mwc-input
                                formControlName="individualUrls"
                                placeholder="Enter URLs, one URL per row"
                                class="upload-urls-textarea"
                                rows="15" (input)="individualUrlsChange()"></textarea>
                    </mwc-form-control>
                    <ng-template #individualUrlsError let-control>
                      <ng-container *ngIf="control?.dirty || control?.touched">
                        <div *ngIf="control?.hasError('invalidUrl')">
                          One or more URLs are invalid. Please enter valid URLs starting with http:// or https://
                        </div>
                        <div *ngIf="control?.hasError('multipleDomainsNotAllowed')">
                          All URLs must belong to the same domain.
                        </div>
                        <div *ngIf="control?.hasError('maxUrlsExceeded')">
                          You can enter a maximum of 300 URLs
                        </div>
                      </ng-container>
                    </ng-template>
                  </mwc-form-item>
                </ng-container>
                <!-- <ng-container *ngIf="isParentUrlVisible && !isIndividualUrlVisible">
                  <div class="mwc-text-sm-medium my-2">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="individualUrlsChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">enter individual URLs</span></a> instead?</div>
                </ng-container>
                <ng-container *ngIf="isIndividualUrlVisible && !isParentUrlVisible">
                  <div class="mwc-text-sm-medium my-2">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="parentUrlChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">enter website/parent URL</span></a> instead?</div>
                </ng-container> -->
              </div>
            </ng-container>
            <!--Instructions-->
            <!--<ng-container *ngIf="tab.name == 'Instructions'">
              <div class="mwc-text-lg-medium mb-3">{{tab.name}}</div>
              <mwc-form-item>
                <mwc-form-label [mwcSpan]="24">Provide instructions need to be considered for Meta generation</mwc-form-label>
                <mwc-form-control style="margin-top: 6px">
                  <textarea formControlName="instructions" mwc-input rows="4" [placeholder]="'Enter'" style="resize: none;" class="mwc-text-sm-regular"></textarea>
                </mwc-form-control>
              </mwc-form-item>
            </ng-container>-->
            <!--Topic Details-->
            <ng-container *ngIf="tab.name == 'Topic Details'">
              <div class="tab-details-header">
                <div class="mwc-text-xl-regular mwc-color-gray-900 ">{{customTemplates?'Page Details':tab.name}}</div>
                <div class="mwc-text-sm-regular mwc-color-gray-500">Set the foundation for your article with a clear topic, keywords, and prompts.</div>
              </div>
              <div class="tab-details-body">
                <div class="topic-details-card mb-4">
                  <mwc-form-item class="mb-0" *ngIf="selectedTemplateTitle === 'Testimonials' || selectedTemplateTitle === 'Reviews'">
                    <mwc-form-label [mwcSpan]="24">What is the name of your product or service?</mwc-form-label>
                    <mwc-form-control>
                      <input placeholder="Enter the name of your product or service" formControlName="serviceName" mwc-input
                            class="mwc-text-sm-regular">
                    </mwc-form-control>
                  </mwc-form-item>
                  <mwc-form-item class="mb-0">
                    <mwc-form-label [mwcSpan]="24">{{titleText}}?</mwc-form-label>
                    <mwc-form-control>
                      <input placeholder="{{placeholderText}}" [(ngModel)]="inputText" formControlName="description" mwc-input class="mwc-text-sm-regular">
                    </mwc-form-control>
                  </mwc-form-item>
                  <div class="topic-suggestions" *ngIf="topicSuggestions.length > 0">
                    <span class="topic-suggestions__label mwc-text-xs-medium">Suggestions:</span>
                    <div style="display: flex;align-items: center;flex-wrap: wrap;gap: 6px;">
                      <button type="button" *ngFor="let suggestion of topicSuggestions" class="topic-suggestions__chip mwc-text-xs-medium"
                            mwc-tooltip [mwcTooltipTitle]="suggestion" (click)="applyTopicSuggestion(suggestion)">
                      {{suggestion}}
                    </button>
                    </div>
                    <button type="button" class="topic-suggestions__refresh" mwc-tooltip mwcTooltipTitle="Refresh suggestions"
                            [disabled]="isTopicSuggestionsLoading" (click)="refreshTopicSuggestions()">
                      <span mwc-icon mwcIconfont="refresh-cw-05" style="font-size: 14px;"></span>
                    </button>
                  </div>
                  <mwc-form-item *ngIf="selectedTemplateTitle === 'Content Outline'" class="mt-3 mb-0">
                    <mwc-form-label [mwcSpan]="24">Select Project Type</mwc-form-label>
                    <mwc-form-control [mwcSpan]="24">
                      <div>
                        <mwc-select class="select-language" mwcSize="small" mwcDropdownClassName="select-language-dropdown"
                                    [mwcShowArrow]="true" [(ngModel)]="selectedValueProjectType" formControlName="projectType"
                                    [mwcCustomTemplate]="defaultTemplate" mwcPlaceHolder="Select Project Type"
                                    class="mwc-xs-select mwc-text-sm-medium select-language" [mwcOptionHeightPx]="36"
                                    (ngModelChange)='languageChanged($event)'>
                          <mwc-option *ngFor="let item of projectTypeData" mwcCustomContent [mwcLabel]="item.label"
                                      [mwcValue]="item.value">
                            {{item.label}} <span mwc-icon [mwcIconfont]="item.value"></span>
                          </mwc-option>
                        </mwc-select>
                        <ng-template #defaultTemplate let-selected>
                          <span mwc-icon [mwcIconfont]="selected.mwcValue"></span>
                          {{ selected.mwcLabel }}
                        </ng-template>
                      </div>
                    </mwc-form-control>
                  </mwc-form-item>
                  <mwc-form-item *ngIf="!isGenericFlow" class="mt-3 mb-0">
                    <mwc-form-label [mwcSpan]="24">What’s the related core topic of your {{selectedTemplateTitle}}?</mwc-form-label>
                    <mwc-form-control>
                      <input placeholder="Enter a related core topic of your article" formControlName="coreTopic" mwc-input
                            class="mwc-text-sm-regular">
                    </mwc-form-control>
                  </mwc-form-item>
                </div>

                <div class="topic-details-card">
                  <div class="prompts-keywords-tabs">
                    <button type="button" class="prompts-keywords-tabs__tab" [class.prompts-keywords-tabs__tab--active]="promptsKeywordsView == 'prompts'" (click)="promptsKeywordsView = 'prompts'">Add Prompts</button>
                    <button type="button" class="prompts-keywords-tabs__tab" [class.prompts-keywords-tabs__tab--active]="promptsKeywordsView == 'keywords'" (click)="promptsKeywordsView = 'keywords'">Add Keywords</button>
                  </div>

                  <div *ngIf="promptsKeywordsView == 'prompts'">
                    <mwc-form-item style="position: relative;margin-bottom: 0px;" class="prompts-keywords-form">
                      <mwc-form-label [mwcSpan]="24">
                        <div class="prompts-keywords-form__label-row">
                          <span>What are the prompts you would like to use?</span>
                          <span class="prompts-keywords-form__count">{{ selectedPrompts.length }}/{{ maxPromptsAllowed }}</span>
                        </div>
                      </mwc-form-label>
                      <mwc-form-control>
                        <div class="selected-keywords" *ngIf="isPromptTagsVisible">
                          <mwc-tag *ngFor="let selectedPrompt of selectedPrompts; let i = index" [mwcMode]="'closeable'"
                                  (mwcOnClose)="removePrompt(selectedPrompt)" class="mwc-input-tag-list mwc-text-xs-medium" mwc-tooltip
                                  [mwcTooltipTitle]="selectedPrompt">
                            <span class="tag-text">{{ selectedPrompt }}</span>
                          </mwc-tag>
                          <span *ngIf="isPromptsPrepopulating && !promptInputVisible"
                                class="mwc-text-sm-regular mwc-color-gray-400"
                                style="width:100%;display:inline-block;">
                            Loading suggested prompts...
                          </span>
                          <span *ngIf="!isPromptsPrepopulating && !promptInputVisible && !(selectedPrompts.length >= maxPromptsAllowed)"
                                mwcNoAnimation (click)="showPromptInput()"
                                class="mwc-text-sm-regular mwc-color-gray-400"
                                style="width:100%;display:inline-block;cursor:pointer;">
                            + Add Prompts
                          </span>
                          <input #promptInputElement mwc-input mwcSize="small" *ngIf="promptInputVisible" type="text"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedPromptInputValue"
                                (blur)="addPromptToSelectedPrompts()" (keydown.enter)="addPromptToSelectedPrompts()"
                                class="mwc-tag-input mwc-text-sm-regular w-100" />
                        </div>
                        <ng-container *ngIf="isPromptUploadVisible">
                          <div class="upload-area" (click)="promptFileInput.click()">
                            <div class="upload-placeholder">
                              <div class="mwc-icon-highlight-primary-lg">
                                <span mwc-icon mwcIconfont="upload-cloud-02" style="font-size: 20px;color: #667085;"></span>
                              </div>
                              <button type="button" mwc-button mwcType="link-color" mwcSize="small" class="mt-2">Click to upload</button>
                              <div class="mwc-text-xs-regular mwc-color-gray-600 mt-1">Upload File Size: Up to 5 MB&nbsp;|&nbsp;Accepted File Type: XLSX, XLS &amp; CSV</div>
                              <input #promptFileInput type="file" accept=".xlsx,.xls,.csv" style="display:none;"
                                    (click)="$event.stopPropagation()" (change)="onPromptFileSelected($event)" />
                            </div>
                          </div>
                          <ng-template #promptSampleUploadErrorIcon>
                            <span mwc-icon mwcIconfont="alert-circle" class="mwc-color-error-600" style="font-size: 20px;"></span>
                          </ng-template>
                          <mwc-alert *ngIf="promptUploadError" mwcType="error" mwcShowIcon="true"
                            [mwcIcon]="promptSampleUploadErrorIcon" [mwcDescription]="promptSampleUploadErrorContent"
                            class="mt-2 upload-error" style="width: 100%;"></mwc-alert>
                          <ng-template #promptSampleUploadErrorContent>
                            <div class="mwc-text-sm-semibold mwc-color-error-700">{{ promptUploadError?.title }}</div>
                            <div class="mwc-text-sm-regular mwc-color-error-700 mt-1">{{ promptUploadError?.description }}</div>
                          </ng-template>
                          <mwc-card *ngIf="promptSampleFile" class="file-upload-card mt-2" style="width: 100%;">
                            <div class="file-upload-content w-100">
                              <div class="file-info-section w-100">
                                <div class="file-icon-wrapper">
                                  <div class="mwc-icon-highlight-primary-md">
                                    <span mwc-icon mwcIconfont="file-04" style="font-size: 16px; color: #155EEF;"></span>
                                  </div>
                                </div>
                                <div class="file-details">
                                  <div class="file-main-info">
                                    <div mwc-typography mwcEllipsis class="file-name mwc-text-sm-medium mwc-color-gray-700 m-0">{{ promptSampleFile.name }}</div>
                                    <div class="file-size mwc-text-sm-regular mwc-color-gray-600">{{ formatSampleFileSize(promptSampleFile.size) }}</div>
                                  </div>
                                  <div class="progress-section" *ngIf="promptUploadPercent !== null && promptUploadPercent < 100">
                                    <div class="progress-bar-container">
                                      <mwc-progress [mwcPercent]="promptUploadPercent" mwcSize="small" [mwcShowInfo]="true"></mwc-progress>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="remove-file-button">
                                <button type="button" mwc-button mwcType="link" mwcSize="small" (click)="removePromptSampleFile()">
                                  <span mwc-icon mwcIconfont="trash-01" style="font-size: 20px; color: #F04438;"></span>
                                </button>
                              </div>
                            </div>
                          </mwc-card>
                          <div class="upload-sample-info">
                            <div class="upload-sample-info-text-sec">
                              <div class="upload-sample-info__icon" aria-hidden="true">
                                <span mwc-icon mwcIconfont="file-02"></span>
                              </div>
                              <div class="upload-sample-info__text">
                                <div class="mwc-text-sm-medium mwc-color-gray-900">Use our pre-formatted template for best results</div>
                                <div class="mwc-text-xs-regular mwc-color-gray-700">Fill in your prompts using the sample file and upload it here</div>
                              </div>
                            </div>
                            <button type="button" mwc-button mwcType="default" class="upload-sample-info__btn" (click)="downloadPromptSample()">
                              <span mwc-icon mwcIconfont="download-02"></span>Download Sample
                            </button>
                          </div>
                        </ng-container>
                      </mwc-form-control>
                      <div class="generate-btn" *ngIf="isPromptTagsVisible">
                        <button [mwcSize]="'small'"
                                mwc-tooltip
                                [mwcTooltipTitle]="( selectedPrompts.length >= maxPromptsAllowed ) ? 'You have already added a maximum of 2 prompts':''"
                                [disabled]="isPromptsPrepopulating || selectedPrompts.length >= maxPromptsAllowed || !(generateAiForm.controls['description'].value?.length > 0) || (!hasKeywordPlanner)"
                                mwc-button (click)="discoverPrompts()" mwcType="link-color"
                                class="mwc-text-xs-semibold" style="padding-left: 0;height: auto;">
                          <span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>Discover Prompts
                        </button>
                        <div class="mwc-text-xs-regular" [ngClass]="selectedPrompts.length ? 'mwc-color-primary-700' : 'mwc-color-gray-400'">Press Enter or , to add each prompt</div>
                      </div>
                    </mwc-form-item>
                    <div class="mwc-text-sm-medium mt-2" *ngIf="isPromptTagsVisible">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: none;" (click)="showPromptUpload()"><span class="mwc-color-primary-700 mwc-text-sm-regular">upload prompts</span></a> instead?</div>
                    <div class="mwc-text-sm-medium mt-2" *ngIf="isPromptUploadVisible">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: none;" (click)="showPromptManual()"><span class="mwc-color-primary-700 mwc-text-sm-regular">add prompts manually</span></a> instead?</div>
                  </div>

                  <div *ngIf="promptsKeywordsView == 'keywords'">
                    <mwc-form-item style="position: relative;margin-bottom: 0px;" class="prompts-keywords-form">
                      <mwc-form-label [mwcSpan]="24">
                        <div class="prompts-keywords-form__label-row">
                          <span>What are the keywords you would like to target?</span>
                          <span class="prompts-keywords-form__count">{{selectedKeywords.length}}/{{maxKeywordsAllowed}}</span>
                        </div>
                      </mwc-form-label>
                      <mwc-form-control>
                        <div class="selected-keywords" *ngIf="isKeywordTagsVisible">
                          <mwc-tag *ngFor="let selectedKeyword of selectedKeywords; let i = index" [mwcMode]="'closeable'"
                                  (mwcOnClose)="removeKeyword(selectedKeyword)" class="mwc-input-tag-list mwc-text-xs-medium" mwc-tooltip
                                  [mwcTooltipTitle]="selectedKeyword">
                            <span class="tag-text">{{ selectedKeyword }}</span>
                          </mwc-tag>
                          <span *ngIf="!keywordInputVisible &&!(selectedKeywords.length >= maxKeywordsAllowed)" class="editable-tag"
                                mwcNoAnimation (click)="showKeywordInput()" class="mwc-text-sm-regular mwc-color-gray-400"
                                style="width:100%;display:inline-block">
                            + More
                            Keyword
                          </span>
                          <input #inputElement mwc-input mwcSize="small" *ngIf="keywordInputVisible" type="text"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedKeywordInputValue"
                                (blur)="addKeywordToSelectedKeywords()" (keydown.enter)="addKeywordToSelectedKeywords()"
                                class="mwc-tag-input mwc-text-sm-regular w-100" />
                        </div>
                        <ng-container *ngIf="isKeywordUploadVisible">
                          <div class="upload-area" (click)="keywordFileInput.click()">
                            <div class="upload-placeholder">
                              <div class="mwc-icon-highlight-primary-lg">
                                <span mwc-icon mwcIconfont="upload-cloud-02" style="font-size: 20px;color: #667085;"></span>
                              </div>
                              <button type="button" mwc-button mwcType="link-color" mwcSize="small" class="mt-2">Click to upload</button>
                              <div class="mwc-text-xs-regular mwc-color-gray-600 mt-1">Upload File Size: Up to 5 MB&nbsp;|&nbsp;Accepted File Type: XLSX, XLS &amp; CSV</div>
                              <input #keywordFileInput type="file" accept=".xlsx,.xls,.csv" style="display:none;"
                                    (click)="$event.stopPropagation()" (change)="onKeywordFileSelected($event)" />
                            </div>
                          </div>
                          <ng-template #keywordSampleUploadErrorIcon>
                            <span mwc-icon mwcIconfont="alert-circle" class="mwc-color-error-600" style="font-size: 20px;"></span>
                          </ng-template>
                          <mwc-alert *ngIf="keywordUploadError" mwcType="error" mwcShowIcon="true"
                            [mwcIcon]="keywordSampleUploadErrorIcon" [mwcDescription]="keywordSampleUploadErrorContent"
                            class="mt-2 upload-error" style="width: 100%;"></mwc-alert>
                          <ng-template #keywordSampleUploadErrorContent>
                            <div class="mwc-text-sm-semibold mwc-color-error-700">{{ keywordUploadError?.title }}</div>
                            <div class="mwc-text-sm-regular mwc-color-error-700 mt-1">{{ keywordUploadError?.description }}</div>
                          </ng-template>
                          <mwc-card *ngIf="keywordSampleFile" class="file-upload-card mt-2" style="width: 100%;">
                            <div class="file-upload-content w-100">
                              <div class="file-info-section w-100">
                                <div class="file-icon-wrapper">
                                  <div class="mwc-icon-highlight-primary-md">
                                    <span mwc-icon mwcIconfont="file-04" style="font-size: 16px; color: #155EEF;"></span>
                                  </div>
                                </div>
                                <div class="file-details">
                                  <div class="file-main-info">
                                    <div mwc-typography mwcEllipsis class="file-name mwc-text-sm-medium mwc-color-gray-700 m-0">{{ keywordSampleFile.name }}</div>
                                    <div class="file-size mwc-text-sm-regular mwc-color-gray-600">{{ formatSampleFileSize(keywordSampleFile.size) }}</div>
                                  </div>
                                  <div class="progress-section" *ngIf="keywordUploadPercent !== null && keywordUploadPercent < 100">
                                    <div class="progress-bar-container">
                                      <mwc-progress [mwcPercent]="keywordUploadPercent" mwcSize="small" [mwcShowInfo]="true"></mwc-progress>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="remove-file-button">
                                <button type="button" mwc-button mwcType="link" mwcSize="small" (click)="removeKeywordSampleFile()">
                                  <span mwc-icon mwcIconfont="trash-01" style="font-size: 20px; color: #F04438;"></span>
                                </button>
                              </div>
                            </div>
                          </mwc-card>
                          <div class="upload-sample-info">
                            <div class="upload-sample-info-text-sec">
                              <div class="upload-sample-info__icon" aria-hidden="true">
                                <span mwc-icon mwcIconfont="file-02"></span>
                              </div>
                              <div class="upload-sample-info__text">
                                <div class="mwc-text-sm-medium mwc-color-gray-900">Use our pre-formatted template for best results</div>
                                <div class="mwc-text-xs-regular mwc-color-gray-700">Fill in your keywords using the sample file and upload it here</div>
                              </div>
                            </div>
                            <button type="button" mwc-button mwcType="default" class="upload-sample-info__btn" (click)="downloadKeywordSample()">
                              <span mwc-icon mwcIconfont="download-02"></span>Download Sample
                            </button>
                          </div>
                        </ng-container>
                      </mwc-form-control>
                      <div class="generate-btn" *ngIf="isKeywordTagsVisible && !(!isSaasUser && !hasKeywordPlanner)">
                        <div class="d-flex align-items-center gap-2">
                          <button mwc-tooltip
                                  [mwcTooltipTitle]="(selectedKeywords.length >= maxKeywordsAllowed ) ? 'You have already added a maximum of 6 keywords':''"
                                  [mwcSize]="'small'"
                                  [disabled]="(selectedKeywords.length >= maxKeywordsAllowed) || !(generateAiForm.controls['description'].value?.length > 0) || (!hasKeywordPlanner)"
                                  mwc-button (click)="selectYourKeywordModal(false,null,true)" mwcType="link-color" class="mwc-text-xs-semibold" style="padding-left: 0;height: auto;">
                            <span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>Discover Keywords
                          </button>
                          <div class="upgrade-plan-msg" *ngIf="!hasKeywordPlanner && isSaasUser">
                            <mwc-alert mwcType="default" [mwcMessage]="msgText" [mwcIcon]="customIconTemplate" mwcShowIcon="true"></mwc-alert>
                            <ng-template #customIconTemplate>
                              <span mwc-icon mwcIconfont="info-circle" style="font-size: 18px;color: #475467;"></span>
                            </ng-template>
                            <ng-template #msgText>
                              <div class="mwc-text-sm-regular mwc-color-gray-700">
                                <a target="_blank" style="text-decoration: underline;" class="mwc-text-sm-regular mwc-color-gray-700" (click)="openCustomerPortal('subscription_update')">Upgrade</a>  to Enable Keyword Recommendations
                              </div>
                            </ng-template>
                          </div>
                        </div>
                        <div class="mwc-text-xs-regular" [ngClass]="selectedKeywords.length ? 'mwc-color-primary-700' : 'mwc-color-gray-400'">Press Enter or , to add each keywords</div>
                      </div>
                    </mwc-form-item>
                    <div class="mwc-text-sm-medium mt-2" *ngIf="isKeywordTagsVisible">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: none;" (click)="showKeywordUpload()"><span class="mwc-color-primary-700 mwc-text-sm-regular">upload keywords</span></a> instead?</div>
                    <div class="mwc-text-sm-medium mt-2" *ngIf="isKeywordUploadVisible">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: none;" (click)="showKeywordManual()"><span class="mwc-color-primary-700 mwc-text-sm-regular">add keywords manually</span></a> instead?</div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!---->
            <ng-container *ngIf="tab.name == 'Content Brief'">
              <div class="tab-details-header">
                <div class="mwc-text-xl-regular mwc-color-gray-900 tab-details-title">{{tab.name}}</div>
                <div class="mwc-text-sm-regular mwc-color-gray-500">Help us understand your content goals to generate more targeted and effective articles.</div>
              </div>
              <div class="tab-details-body">
                <mwc-spin [mwcIndicator]="customSpinTpl" [mwcSpinning]="isLoading" class="content-brief-spin">
                  <div class="details-card content-brief-card">
                    <ng-container *ngIf="isQuestionExist; else elseBlock">
                      <mwc-form-item style="margin:0;" *ngFor="let question of questionsFromAI; let i = index">
                        <mwc-form-label [mwcSpan]="24">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="mwc-text-sm-medium question-dv"> {{question}} <a mwc-button mwcType="link-color" class="question-refresh-btn"
                                 mwc-tooltip mwcTooltipTitle="Regenerate this question"
                                 [mwcLoading]="refreshingQuestionIndex === i"
                                 [disabled]="refreshingQuestionIndex !== -1"
                                 (click)="refreshQuestion(i)"><span mwc-icon mwcIconfont="refresh-cw-05" *ngIf="refreshingQuestionIndex !== i"></span></a></div>
                            <div class="mwc-text-xs-regular" [ngClass]="getWordCount(generateAiForm.controls['AnswerAI' + i].value) > contentBriefMaxWords ? 'mwc-color-error-600' : 'mwc-color-gray-600'">{{getWordCount(generateAiForm.controls['AnswerAI' + i].value)}}/{{contentBriefMaxWords}} words</div>
                          </div>
                        </mwc-form-label>
                        <mwc-form-control style="margin-top: 6px" [mwcErrorTip]="wordLimitError">
                          <textarea formControlName="AnswerAI{{i}}" mwc-input rows="4" [placeholder]="'Enter your answer'" style="resize: none;" class="mwc-text-sm-regular"></textarea>
                        </mwc-form-control>
                        <ng-template #wordLimitError let-control>
                          <div *ngIf="control?.hasError('maxWordsExceeded')">Limit exceeded: {{control.errors.maxWordsExceeded.actual}}/{{contentBriefMaxWords}} words. Please shorten your answer.</div>
                        </ng-template>
                      </mwc-form-item>
                    </ng-container>
                    <ng-template #elseBlock>
                      <mwc-form-item style="margin: 0;">
                        <mwc-form-label [mwcSpan]="24">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="mwc-text-sm-medium question-dv">What do you want the reader to know about {{inputText}}? <a mwc-button mwcType="link-color" class="question-refresh-btn"><span mwc-icon mwcIconfont="refresh-cw-05"></span></a></div>
                            <div class="mwc-text-xs-regular" [ngClass]="getWordCount(generateAiForm.controls['FirstAnswer'].value) > contentBriefMaxWords ? 'mwc-color-error-600' : 'mwc-color-gray-600'">{{getWordCount(generateAiForm.controls['FirstAnswer'].value)}}/{{contentBriefMaxWords}} words</div>
                          </div>
                        </mwc-form-label>
                        <mwc-form-control style="margin-top: 6px" [mwcErrorTip]="firstAnswerWordLimitError">
                          <textarea formControlName="FirstAnswer" mwc-input rows="4" [placeholder]="'Enter your answer'" style="resize: none;" class="mwc-text-sm-regular"></textarea>
                        </mwc-form-control>
                        <ng-template #firstAnswerWordLimitError let-control>
                          <div *ngIf="control?.hasError('maxWordsExceeded')">Limit exceeded: {{control.errors.maxWordsExceeded.actual}}/{{contentBriefMaxWords}} words. Please shorten your answer.</div>
                        </ng-template>
                      </mwc-form-item>
                      <mwc-form-item style="margin: 0;">
                        <mwc-form-label [mwcSpan]="24">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="mwc-text-sm-medium question-dv">What facts do you want to convey about {{inputText}}? <a mwc-button mwcType="link-color" class="question-refresh-btn"><span mwc-icon mwcIconfont="refresh-cw-05"></span></a></div>
                            <div class="mwc-text-xs-regular" [ngClass]="getWordCount(generateAiForm.controls['SecondAnswer'].value) > contentBriefMaxWords ? 'mwc-color-error-600' : 'mwc-color-gray-600'">{{getWordCount(generateAiForm.controls['SecondAnswer'].value)}}/{{contentBriefMaxWords}} words</div>
                          </div>
                        </mwc-form-label>
                        <mwc-form-control style="margin-top: 6px" [mwcErrorTip]="secondAnswerWordLimitError">
                          <textarea formControlName="SecondAnswer" mwc-input rows="3" [placeholder]="'Enter your answer'" style="resize: none;" class="mwc-text-sm-regular"></textarea>
                        </mwc-form-control>
                        <ng-template #secondAnswerWordLimitError let-control>
                          <div *ngIf="control?.hasError('maxWordsExceeded')">Limit exceeded: {{control.errors.maxWordsExceeded.actual}}/{{contentBriefMaxWords}} words. Please shorten your answer.</div>
                        </ng-template>
                      </mwc-form-item>
                      <mwc-form-item style="margin:0">
                        <mwc-form-label [mwcSpan]="24">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="mwc-text-sm-medium question-dv">Do you want to include any additional information for reference? <a mwc-button mwcType="link-color" class="question-refresh-btn"><span mwc-icon mwcIconfont="refresh-cw-05"></span></a></div>
                            <div class="mwc-text-xs-regular" [ngClass]="getWordCount(generateAiForm.controls['ThirdAnswer'].value) > contentBriefMaxWords ? 'mwc-color-error-600' : 'mwc-color-gray-600'">{{getWordCount(generateAiForm.controls['ThirdAnswer'].value)}}/{{contentBriefMaxWords}} words</div>
                          </div>
                        </mwc-form-label>
                        <mwc-form-control style="margin-top: 6px" [mwcErrorTip]="thirdAnswerWordLimitError">
                          <textarea formControlName="ThirdAnswer" mwc-input rows="3" [placeholder]="'Enter your answer'" style="resize: none;" class="mwc-text-sm-regular"></textarea>
                        </mwc-form-control>
                        <ng-template #thirdAnswerWordLimitError let-control>
                          <div *ngIf="control?.hasError('maxWordsExceeded')">Limit exceeded: {{control.errors.maxWordsExceeded.actual}}/{{contentBriefMaxWords}} words. Please shorten your answer.</div>
                        </ng-template>
                      </mwc-form-item>
                    </ng-template>
                  </div>
                </mwc-spin>
              </div>
            </ng-container>
            <!--Preferences (Brand Voice + Target Audience + Language + Intent/Goal consolidated)-->
            <ng-container *ngIf="tab.name == 'Preferences'">
              <div class="tab-details-header">
                <div class="mwc-text-lg-medium mwc-color-gray-900 tab-details-title">Preferences</div>
                <div class="mwc-text-sm-regular mwc-color-gray-500">Customize the tone, audience, and language to match your brand perfectly.</div>
              </div>
              <div class="tab-details-body">
                <div class="topic-details-card">
                  <div class="preference-field">
                    <div class="mwc-text-sm-medium mb-1">Brand Voice</div>
                    <mwc-select mwcSize="small" mwcDropdownClassName="preference-select-dropdown"
                                [mwcShowArrow]="true" [ngModel]="selectedBrandVoice" [ngModelOptions]="{standalone: true}"
                                [mwcCustomTemplate]="brandVoiceSelectedTemplate" mwcPlaceHolder="Select Brand Voice"
                                class="mwc-xs-select mwc-text-sm-medium preference-select" style="width: 100%;" [mwcOptionHeightPx]="36"
                                [mwcDropdownRender]="brandVoiceFooter"
                                (ngModelChange)="selectedBrandVoice = $event; brandVoiceChange($event)">
                      <mwc-option *ngFor="let bv of brandVoiceList" mwcCustomContent [mwcLabel]="bv.label" [mwcValue]="bv.value">
                        <div class="preference-option-row" style="pointer-events: none;">
                          <div class="preference-option-row__name">
                            <span mwc-icon mwcIconfont="clipboard-report" class="preference-option-row__icon"></span>
                            <span class="preference-option-row__label mwc-text-sm-regular">{{bv.label}}</span>
                          </div>
                          <div class="preference-option-row__divider"></div>
                          <div class="preference-option-row__badges">
                            <mwc-tag class="preference-option-row__badge mwc-text-xs-regular" mwcColor="gray">{{bv.tone}}</mwc-tag>
                          </div>
                          <span mwc-icon mwcIconfont="check" class="preference-option-row__check" *ngIf="bv.value == selectedBrandVoice"></span>
                        </div>
                      </mwc-option>
                    </mwc-select>
                    <ng-template #brandVoiceSelectedTemplate let-selected>
                      <span mwc-icon mwcIconfont="clipboard-report"></span>
                      <span class="preference-select-trigger__label">{{selected.mwcLabel}}</span>
                      <span class="preference-dropdown-trigger__divider" *ngIf="brandVoiceDetails?.tone"></span>
                      <mwc-tag *ngIf="brandVoiceDetails?.tone" class="mwc-text-xs-regular" mwcColor="gray">{{brandVoiceDetails.tone}}</mwc-tag>
                    </ng-template>
                    <ng-template #brandVoiceFooter>
                      <a class="preference-add-link" (click)="openRedirectToMPC('brandVoice')">
                        <span mwc-icon mwcIconfont="plus"></span>Add Brand Voice<span mwc-icon mwcIconfont="link-external-02"></span>
                      </a>
                    </ng-template>
                  </div>

                  <div class="preference-field">
                    <div class="mwc-text-sm-medium mb-1">Target Audience</div>
                    <mwc-select mwcSize="small" mwcDropdownClassName="preference-select-dropdown"
                                [mwcShowArrow]="true" [ngModel]="selectedTargetAudience" [ngModelOptions]="{standalone: true}"
                                [mwcCustomTemplate]="targetAudienceSelectedTemplate" mwcPlaceHolder="Select Target Audience"
                                class="mwc-xs-select mwc-text-sm-medium preference-select" style="width: 100%;" [mwcOptionHeightPx]="36"
                                [mwcDropdownRender]="targetAudienceFooter"
                                (ngModelChange)="selectedTargetAudience = $event; targetAudienceChange($event)">
                      <mwc-option *ngFor="let ta of targetAudienceList" mwcCustomContent [mwcLabel]="ta.title" [mwcValue]="ta.title">
                        <div class="preference-option-row" style="pointer-events: none;">
                          <div class="preference-option-row__name">
                            <span mwc-icon mwcIconfont="users-03" class="preference-option-row__icon"></span>
                            <span class="preference-option-row__label mwc-text-sm-regular">{{ta.title}}</span>
                          </div>
                          <div class="preference-option-row__divider"></div>
                          <div class="preference-option-row__badges">
                            <mwc-tag *ngFor="let g of ta.thingTargetAudience.thingJson.gender" class="preference-option-row__badge preference-option-row__badge--accent mwc-text-xs-regular" mwcColor="gray">{{g}}</mwc-tag>
                            <mwc-tag *ngFor="let ag of ta.thingTargetAudience.thingJson.ageGroup" class="preference-option-row__badge mwc-text-xs-regular" mwcColor="gray">{{ag}}</mwc-tag>
                          </div>
                          <span mwc-icon mwcIconfont="check" class="preference-option-row__check" *ngIf="ta.title == selectedTargetAudience"></span>
                        </div>
                      </mwc-option>
                    </mwc-select>
                    <ng-template #targetAudienceSelectedTemplate let-selected>
                      <span mwc-icon mwcIconfont="users-03"></span>
                      <span class="preference-select-trigger__label">{{selected.mwcLabel}}</span>
                      <ng-container *ngIf="targetAudienceDetails?.thingTargetAudience?.thingJson as ta">
                        <span class="preference-dropdown-trigger__divider"></span>
                        <mwc-tag *ngFor="let g of ta.gender" class="preference-option-row__badge preference-option-row__badge--accent mwc-text-xs-regular" mwcColor="gray">{{g}}</mwc-tag>
                        <mwc-tag *ngFor="let ag of ta.ageGroup" class="preference-option-row__badge mwc-text-xs-regular" mwcColor="gray">{{ag}}</mwc-tag>
                      </ng-container>
                    </ng-template>
                    <ng-template #targetAudienceFooter>
                      <a class="preference-add-link" (click)="openRedirectToMPC('targetAudience')">
                        <span mwc-icon mwcIconfont="plus"></span>Add Target Audience<span mwc-icon mwcIconfont="link-external-02"></span>
                      </a>
                    </ng-template>
                  </div>

                  <div class="preference-field">
                    <div class="mwc-text-sm-medium mb-1">Language</div>
                    <mwc-select mwcSize="small" mwcDropdownClassName="select-language-dropdown"
                                [mwcShowArrow]="true" [(ngModel)]="selectedValueLanguage" formControlName="language"
                                [mwcCustomTemplate]="preferenceLanguageTemplate" mwcPlaceHolder="Select language"
                                class="mwc-xs-select mwc-text-sm-medium select-language" style="width: 100%;" [mwcOptionHeightPx]="36"
                                (ngModelChange)='languageChanged($event)'>
                      <mwc-option *ngFor="let item of provinceData" mwcCustomContent [mwcLabel]="item.label"
                                  [mwcValue]="item.value">
                        {{item.label}} <span mwc-icon [mwcIconfont]="item.value"></span>
                      </mwc-option>
                    </mwc-select>
                    <ng-template #preferenceLanguageTemplate let-selected>
                      <span mwc-icon [mwcIconfont]="selected.mwcValue"></span>
                      {{ selected.mwcLabel }}
                    </ng-template>
                  </div>

                  <div class="preference-field" *ngIf="isSettingsEnableKnowledgeVault && knowledgeVaultVisibility">
                    <div class="mwc-text-sm-medium mb-1 d-flex align-items-center gap-2">
                      Knowledge Vault
                      <mwc-tag mwcColor="primary" class="mwc-text-xs-medium" style="margin:0;">New</mwc-tag>
                    </div>
                    <div class="preference-toggle-row">
                      <div class="d-flex align-items-center gap-1">
                        <span class="mwc-text-sm-medium mwc-color-gray-900">Do you want to use Knowledge Vault for generating this?</span>
                        <a class="mwc-text-sm-medium mwc-color-primary-700 d-flex align-items-center gap-1" style="cursor:pointer;" (click)="openRedirectToMPC('knowledgeVault')">
                          Manage <span mwc-icon mwcIconfont="link-external-02" style="font-size: 14px;"></span>
                        </a>
                      </div>
                      <mwc-switch formControlName="isKnowledgeVaultEnable" (ngModelChange)="onVisibilityToggle($event)"></mwc-switch>
                    </div>
                    <mwc-alert class="mt-2" *ngIf="isKnowledgeVaultEnable" mwcType="info" [mwcMessage]="kvDisclaimerTemplate" mwcShowIcon="true"></mwc-alert>
                    <ng-template #kvDisclaimerTemplate>
                      <div class="mwc-text-sm-medium mwc-color-gray-900">Important Disclaimer</div>
                      <div class="mwc-text-sm-regular mwc-color-gray-600">AI-generated content relies on the provided sources and context available at generation, though some inputs may not be fully integrated into the final output. Users should review and validate all outputs for accuracy, completeness, and compliance before publishing.</div>
                    </ng-template>
                  </div>

                  <div class="preference-field mt-3">
                    <div class="mwc-text-sm-medium mb-1">Intent</div>
                    <mwc-select mwcSize="small" mwcDropdownClassName="preference-select-dropdown"
                                [mwcShowArrow]="true" [ngModel]="selectedGoalDetail?.title" [ngModelOptions]="{standalone: true}"
                                [mwcCustomTemplate]="intentSelectedTemplate" mwcPlaceHolder="Select Intent"
                                class="mwc-xs-select mwc-text-sm-medium preference-select" style="width: 100%;" [mwcOptionHeightPx]="36"
                                (ngModelChange)="SelectedGoal($event)">
                      <mwc-option *ngFor="let goal of goalsList" mwcCustomContent [mwcLabel]="goal.title" [mwcValue]="goal.title">
                        <div class="preference-option-row" style="pointer-events: none;">
                          <span mwc-icon [mwcIconfont]="goal.icon" class="preference-option-row__icon"></span>
                          <span class="preference-option-row__label mwc-text-sm-regular" style="flex: 1;">{{goal.title}}</span>
                          <span mwc-icon mwcIconfont="check" class="preference-option-row__check" *ngIf="goal.isSelectedGoal"></span>
                        </div>
                      </mwc-option>
                    </mwc-select>
                    <ng-template #intentSelectedTemplate let-selected>
                      <span mwc-icon [mwcIconfont]="selectedGoalDetail?.icon || 'target-04'"></span>
                      <span class="preference-select-trigger__label">{{selected.mwcLabel}}</span>
                    </ng-template>
                  </div>

                  <div mwc-row [mwcGutter]="24" class="mt-3">
                    <div mwc-col [mwcSpan]="12">
                      <div class="preference-field mb-0">
                        <div class="mwc-text-sm-medium mb-1">Word Count</div>
                        <mwc-select mwcSize="small" [(ngModel)]="wordCountPlaceholder" [ngModelOptions]="{standalone: true}" [mwcDropdownClassName]="'mwc-xs-select-dropdown'" [mwcOptionHeightPx]="38" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 100%;">
                          <mwc-option *ngFor="let wc of wordCountOptions" [mwcLabel]="wc" [mwcValue]="wc"></mwc-option>
                        </mwc-select>
                      </div>
                    </div>
                    <div mwc-col [mwcSpan]="12">
                      <div class="preference-field mb-0">
                        <div class="mwc-text-sm-medium mb-1">Internal Links</div>
                        <div class="preference-toggle-row">
                          <span class="mwc-text-sm-regular mwc-color-gray-400">Connect articles with contextual internal links.</span>
                          <mwc-switch formControlName="isInternalLinksEnable" (ngModelChange)="onVisibilityToggleIL($event)"></mwc-switch>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="preference-field mt-3 mb-0">
                    <div class="mwc-text-sm-medium mb-1">Author Name</div>
                    <mwc-select id="author-name-element" #authorSelectDropdown mwcSize="small"
                                [(ngModel)]="authorNamePlaceholder" [ngModelOptions]="{standalone: true}"
                                class="mwc-text-sm-regular" style="width: 100%;"
                                [mwcOptionHeightPx]="38" [mwcDropdownRender]="authorRenderTemplate">
                      <mwc-option *ngFor="let author of authorOptions" [mwcValue]="author"
                                  [mwcLabel]="author"></mwc-option>
                    </mwc-select>
                    <ng-template #authorRenderTemplate>
                      <mwc-divider style="margin: 0;"></mwc-divider>
                      <div class="container px-1 py-2">
                        <a mwc-button mwcType="link-color" class="ms-1"
                           (click)="openManualAuthorPanel();authorSelectDropdown.setOpenState(false)">
                          <span mwc-icon mwcIconfont="plus"></span>
                          <ng-container i18n="@@bs-create-new-modal-author-add-manually-text">Add Manually</ng-container>
                        </a>
                      </div>
                    </ng-template>
                    <div class="author-manual-panel" *ngIf="showManualAuthorPanel">
                      <div i18n="@@bs-create-new-modal-author-manual-name-text" class="mwc-text-sm-medium mb-1">Name</div>
                      <input id="author-manual-name-element" mwc-input mwcSize="small"
                             [(ngModel)]="manualAuthorName" [ngModelOptions]="{standalone: true}"
                             class="mwc-text-sm-regular" (keyup.enter)="addManualAuthor()" />
                      <div class="author-manual-actions">
                        <button mwc-button mwcType="default" mwcSize="small" (click)="cancelManualAuthor()"
                                i18n="@@bs-create-new-modal-author-manual-cancel-text">Cancel</button>
                        <button mwc-button mwcType="primary" mwcSize="small" (click)="addManualAuthor()"
                                [disabled]="!manualAuthorName?.trim()"
                                i18n="@@bs-create-new-modal-author-manual-add-text">Add</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!--Brand Voice-->
            <ng-container *ngIf="tab.name == 'Brand Voice'">
              <ng-container [ngTemplateOutlet]="brandVoiceContent"></ng-container>
            </ng-container>
            <ng-template #brandVoiceContent>
              <ng-container *ngIf="isNoCreateBrandVoice">
                <div class="empty-screen-branch-voice">
                  <div><img src="../../assets/images/Illustration-no-brand-voice.svg" /></div>
                  <div>
                    <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Brand Voice Found!</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Add a brand voice using the button below to start creating intelligent content</div>
                  </div>
                  <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('brandVoice')" class="mwc-text-sm-medium"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span>Create Brand Voice</button>
                </div>
              </ng-container>
              <ng-container *ngIf="!isNoCreateBrandVoice">
                <div class="d-flex align-items-center mb-3 justify-content-between">
                  <div class="mwc-text-lg-medium">{{tab.name}}</div>
                  <div class="d-flex align-items-center gap-2">
                    <ng-container *ngIf="!isShowDetailsBV">
                      <button mwc-button mwcType="link" mwcSize="small" (click)="reloadList('brandVoice')" style="margin-right: 8px;"><span mwc-icon mwcIconfont="refresh-ccw-01" style="font-size: 16px;"></span> Refresh </button>
                      <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('brandVoice')"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span> Create New </button>
                    </ng-container>
                    <ng-container *ngIf="isShowDetailsBV">
                      <button mwc-button mwcType="default-color" mwcSize="small" (click)="changeBV()"><span mwc-icon mwcIconfont="arrow-left" style="font-size: 18px;"></span> Change Brand Voice </button>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngIf="!isShowDetailsBV">
                  <div style="width: 100%;margin: 0 auto 16px 0;">
                    <mwc-input-group [mwcPrefix]="prefixIconSearch">
                      <input mwc-input [formControl]="bvSearchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearchBV()" placeholder="Search from all existing brand voices by name" mwcSize="small" />
                    </mwc-input-group>
                    <ng-template #prefixIconSearch>
                      <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="!FoundSerchBV">
                    <div class="empty-screen-branch-voice">
                      <div><img src="../../assets/images/Illustration-no-brand-voice.svg" /></div>
                      <div>
                        <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Brand Voice Found!</div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="grid-sec" *ngIf="FoundSerchBV">
                    <mwc-card *ngFor="let bvCard of filteredBrandVoiceList; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;" [ngClass]="(bvCard.isDefault || bvCard.isSelectedBV) ? 'select-grid':''">
                      <div class="get-started-overlay">
                        <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedBV(bvCard.value)">
                          <span class="mwc-text-sm-medium">{{(bvCard.isDefault || bvCard.isSelectedBV) ? 'Selected' : 'Select'}}</span>
                        </button>
                        <a mwc-button mwcType="link-color" mwcSize="small" class="mwc-text-sm-medium" (click)="selectBV(bvCard.value)">
                          <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                          <span class="mwc-text-sm-medium">View Details</span>
                        </a>
                      </div>
                      <div>
                        <div class="d-flex align-items-center justify-content-between mb-1">
                          <div mwc-typography mwcEllipsis class="mwc-text-md-medium m-0">{{bvCard.label}}</div>
                        </div>
                        <div class="mwc-text-xs-regular"><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(bvCard.createdOn)}}</span></div>
                        <div class="mwc-text-xs-regular mt-3 mb-1"><span class="mwc-text-xs-regular mwc-color-gray-500">Tone: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{bvCard.tone}}</span></div>
                        <div class="mwc-text-xs-regular"><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{bvCard.createdBy}}</span></div>
                      </div>
                    </mwc-card>
                  </div>
                </ng-container>
                <ng-container *ngIf="isShowDetailsBV">
                  <div style="width: 100%;margin-top: 16px; padding-left: 16px; padding-right: 16px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 12px; border: 1px #D0D5DD solid;">
                    <div style="display: flex;align-items: flex-start;gap: 8px;justify-content: space-between;border-bottom: 1px solid #EAECF0;padding-bottom: 12px;">
                      <div class="d-flex align-items-center gap-2">
                        <div style="width: 40px; height: 40px; padding: 10px; background: #EAECF0; border-radius: 20px; justify-content: center; align-items: center; display: flex">
                          <div style="display: flex; color: #667085">
                            <span mwc-icon mwcIconfont="clipboard-report"></span>
                          </div>
                        </div>
                        <div>
                          <div class="mwc-text-md-medium mwc-color-gray-700">{{brandVoiceDetails?.label}}</div>
                          <div style="display: flex;align-items: center;gap:8px">
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Tone: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{brandVoiceDetails?.tone}}</span></div>
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{brandVoiceDetails?.createdBy}}</span></div>
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(brandVoiceDetails?.createdOn)}}</span></div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label mwc-checkbox class="mt-1" [mwcSize]="'small'" [(mwcChecked)]="isDefaultBVAvailable"><span class="mwc-text-xs-medium">Save Selection for Later</span></label>
                      </div>
                    </div>
                    <div style="margin: 12px 0 0;">
                      <div class="mwc-text-sm-regular mwc-color-gray-500" [innerHTML]="brandVoiceDetails.brandVoiceDocument" style="white-space: pre-wrap;"></div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-template>
            <!--Target Audience-->
            <ng-container *ngIf="tab.name == 'Target Audience'">
              <ng-container [ngTemplateOutlet]="targetAudienceContent"></ng-container>
            </ng-container>
            <ng-template #targetAudienceContent>
              <ng-container *ngIf="isNoTargetAudience">
                <div class="empty-screen-branch-voice">
                  <div><img src="../../assets/images/Illustration-no-target-audience.svg" /></div>
                  <div>
                    <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No target audience found</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Add a target audience using the button below to start creating intelligent content</div>
                  </div>
                  <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('targetAudience')" class="mwc-text-sm-medium"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span>Create Target Audience</button>
                </div>
              </ng-container>
              <ng-container *ngIf="!isNoTargetAudience">
                <div class="d-flex align-items-center mb-3 justify-content-between">
                  <div class="mwc-text-lg-medium">{{tab.name}}</div>
                  <div class="d-flex align-items-center gap-2">
                    <ng-container *ngIf="!isShowDetailsTA">
                      <button mwc-button mwcType="link" mwcSize="small" (click)="reloadList('targetAudience')" style="margin-right: 8px;"><span mwc-icon mwcIconfont="refresh-ccw-01" style="font-size: 16px;"></span> Refresh </button>
                      <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('targetAudience')"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span> Create New </button>
                    </ng-container>
                    <ng-container *ngIf="isShowDetailsTA">
                      <button mwc-button mwcType="default" mwcSize="small" (click)="viewAllTA()"><span mwc-icon mwcIconfont="arrow-left" style="font-size: 18px;"></span>View all </button>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngIf="!isShowDetailsTA">
                  <div style="width: 100%;margin: 0 auto 16px 0;">
                    <mwc-input-group [mwcPrefix]="prefixIconSearch">
                      <input mwc-input [formControl]="tvSearchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearchTA()" placeholder="Search from all existing personas by name" mwcSize="small" />
                    </mwc-input-group>
                    <ng-template #prefixIconSearch>
                      <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="!FoundSearchTA">
                    <div class="empty-screen-branch-voice">
                      <div><img src="../../assets/images/Illustration-no-target-audience.svg" /></div>
                      <div>
                        <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No target audience found</div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="grid-sec" *ngIf="FoundSearchTA">
                    <mwc-card *ngFor="let taCard of filteredTargetAudienceList; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;" [ngClass]="(taCard.isDefault || taCard.isSelectedTA) ? 'select-grid':''">
                      <div class="get-started-overlay">
                        <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedTA(taCard.title)">
                          <span class="mwc-text-sm-medium">{{ taCard.isDefault || taCard.isSelectedTA ? 'Selected': 'Select' }}</span>
                        </button>
                        <a mwc-button mwcType="link-color" mwcSize="small" class="mwc-text-sm-medium" (click)="selectTV(taCard.title)">
                          <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                          <span class="mwc-text-sm-medium">View Details</span>
                        </a>
                      </div>
                      <div>
                        <div class="d-flex align-items-center justify-content-between">
                          <div mwc-typography mwcEllipsis class="mwc-text-md-medium m-0">{{taCard.title}}</div>
                        </div>
                        <div class="mb-2"><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(taCard.createdDate)}}</span></div>
                        <div style="line-height: normal;">
                          <span class="mwc-text-xs-regular mwc-color-gray-500">Gender: </span>
                          <ng-container *ngFor="let gender of taCard.thingTargetAudience.thingJson.gender;let last = last; let first = first;">
                            <span class="mwc-text-xs-medium mwc-color-gray-700">{{gender}}</span> <span class="me-1" *ngIf="!last">{{!last ? ',' : '&'}}</span>
                          </ng-container>
                        </div>
                        <div style="line-height: normal;">
                          <span class="mwc-text-xs-regular mwc-color-gray-500">Age group: </span>
                          <ng-container *ngFor="let age of taCard.thingTargetAudience.thingJson.ageGroup;let last = last;">
                            <span class="mwc-text-xs-medium mwc-color-gray-700">{{age}}</span>
                            <span class="me-1" *ngIf="!last">{{taCard.thingTargetAudience.thingJson.ageGroup.length - 1  ? ',' : '&'}}</span>
                          </ng-container>
                        </div>
                      </div>
                    </mwc-card>
                  </div>
                </ng-container>
                <ng-container *ngIf="isShowDetailsTA">
                  <div style="width: 100%;margin-top: 16px; padding-left: 16px; padding-right: 16px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 12px; border: 1px #D0D5DD solid;">
                    <div style="display: flex;align-items: center;gap: 8px;justify-content: space-between;">
                      <div class="d-flex align-items-center gap-2">
                        <div style="min-width: 40px; height: 40px; padding: 10px; background: #EAECF0; border-radius: 20px; justify-content: center; align-items: center; display: flex">
                          <div style="display: flex; color: #667085">
                            <span mwc-icon mwcIconfont="users-03"></span>
                          </div>
                        </div>
                        <div>
                          <div class="mwc-text-md-medium mwc-color-gray-700" mwc-typography mwcEllipsis style="margin: 0;width: 86%;">{{targetAudienceDetails?.title}}</div>
                          <div style="display: flex;align-items: center;gap:8px">
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{targetAudienceDetails?.authorName}}</span></div>
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(targetAudienceDetails.createdDate)}}</span></div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label mwc-checkbox class="mt-1" [mwcSize]="'small'" [(mwcChecked)]="isDefaultTAAvailable"><span class="mwc-text-xs-medium">Save Selection for Later</span></label>
                      </div>
                    </div>
                    <div style="margin-top: 12px;border-top: 1px solid #efefef;padding-top: 10px;">
                      <div mwc-row [mwcGutter]="[24,12]">
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1"> Age Group: </div>
                          <ng-container>
                            <div class="view-layout">
                              <ng-container *ngFor="let age of targetAudienceDetails.thingTargetAudience.thingJson.ageGroup;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium mwc-color-gray-700">{{age}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </ng-container>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Family Status:</div>
                          <ng-container>
                            <div class="view-layout">
                              <div *ngFor="let status of targetAudienceDetails.thingTargetAudience.thingJson.relationshipStatus;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium">{{status}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Gender:</div>
                          <ng-container>
                            <div class="view-layout">
                              <div *ngFor="let gender of targetAudienceDetails.thingTargetAudience.thingJson.gender;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium">{{gender}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Intent:</div>
                          <div><span class="mwc-text-sm-medium">{{targetAudienceDetails.thingTargetAudience.thingJson.intent}}</span></div>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Industry:</div>
                          <ng-container>
                            <div class="view-layout">
                              <div *ngFor="let industry of targetAudienceDetails.thingTargetAudience.thingJson.industry;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium">{{industry}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Interests:</div>
                          <div style="display: flex;gap:16px;align-items: center;">
                            <ng-container>
                              <div class="view-layout">
                                <div *ngFor="let interests of targetAudienceDetails.thingTargetAudience.thingJson.interests;let last = last; let first = first;">
                                  <span class="mwc-text-sm-medium">{{interests}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-template>
            <!--Content Outline - the structure returned by api/Article/GenerateContentOutline, built
                 from everything the earlier steps collected. Editable here, then sent back with
                 "Generate Blog Post" so the article follows the structure that was approved.-->
            <ng-container *ngIf="tab.name == 'Content Outline'">
              <div class="tab-details-header d-flex align-items-center justify-content-between">
                <div>
                  <div class="mwc-text-lg-medium mwc-color-gray-900">Content Outline</div>
                  <div class="mwc-text-sm-regular mwc-color-gray-600 mt-1">Customize the structure before generating your full article</div>
                </div>
                <div class="d-flex align-items-center gap-2" *ngIf="outlineGenerated && !isGeneratingOutline">
                  <button mwc-button mwcType="default" mwcSize="small" (click)="addOutlineSection()">
                    <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>Add Section
                  </button>
                  <button mwc-button mwcType="default-color" mwcSize="small" (click)="regenerateOutline()">
                    <span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>Regenerate Outline
                  </button>
                </div>
              </div>
              <div class="tab-details-body">
                <div class="topic-details-card outline-loading-card" *ngIf="isGeneratingOutline">
                  <div class="outline-loading">
                    <div class="mwc-text-xl-regular mwc-color-gray-900">Generation in progress...</div>
                    <div class="outline-loading__icon">
                      <img src="assets/images/stars-gif.gif" alt="" />
                    </div>
                    <ng-container *ngIf="outlineTips[activeOutlineTipIndex] as tip">
                      <div class="outline-loading__label mwc-text-xs-medium mwc-color-gray-500">SEO Tips</div>
                      <div class="outline-loading__tip" aria-live="polite">
                        <div class="mwc-text-sm-medium mwc-color-gray-900">{{tip.title}}</div>
                        <div class="mwc-text-sm-regular mwc-color-gray-600">{{tip.desc}}</div>
                      </div>
                    </ng-container>
                    <div class="outline-loading__dots">
                      <span *ngFor="let tip of outlineTips; let tipIndex = index" class="outline-loading__dot" [class.outline-loading__dot--active]="tipIndex == activeOutlineTipIndex"></span>
                    </div>
                  </div>
                </div>

                <!--Failed or empty generation. Offers a retry, and a way to write the outline by
                     hand so a generation that will not come back is not a dead end.-->
                <div class="topic-details-card outline-error-card" *ngIf="outlineError && !isGeneratingOutline">
                  <div class="outline-error">
                    <span mwc-icon mwcIconfont="alert-circle" class="outline-error__icon"></span>
                    <div class="mwc-text-md-medium mwc-color-gray-900">Outline generation failed</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600 mt-1">{{outlineError}}</div>
                    <div class="d-flex align-items-center justify-content-center gap-2 mt-3">
                      <button mwc-button mwcType="primary" mwcSize="small" (click)="regenerateOutline()">
                        <span mwc-icon mwcIconfont="refresh-cw-01" style="font-size: 16px;"></span>Try Again
                      </button>
                      <button mwc-button mwcType="default" mwcSize="small" (click)="startOutlineFromScratch()">
                        <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>Build It Myself
                      </button>
                    </div>
                  </div>
                </div>

                <ng-container *ngIf="outlineGenerated && !isGeneratingOutline">
                  <div class="outline-section-list" cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="onOutlineSectionDrop($event)">
                  <div class="outline-section-card" cdkDrag cdkDragPreviewContainer="parent" *ngFor="let section of outlineSections; let sectionIndex = index">
                    <div class="outline-section-card__header">
                      <div class="outline-section-card__drag-handle" cdkDragHandle>
                        <span mwc-icon mwcIconfont="dots-vertical" class="mwc-color-gray-600" style="height: 10px;width: 6px; color: #344054;"></span>
                        <span mwc-icon mwcIconfont="dots-vertical" class="mwc-color-gray-600" style="height: 10px;width: 22px;color: #344054;"></span>
                      </div>
                      <div class="outline-section-card__number">{{sectionIndex + 1}}</div>
                      <mwc-input-group class="outline-section-card__input-group" [mwcSuffix]="headerSuffix">
                        <input mwc-input [(ngModel)]="section.header" [ngModelOptions]="{standalone: true}" placeholder="Section header" class="mwc-text-sm-medium">
                      </mwc-input-group>
                      <ng-template #headerSuffix><span class="mwc-text-xs-regular mwc-color-gray-400">Header</span></ng-template>
                      <button mwc-button mwcType="text" class="outline-section-card__delete" (click)="openDeleteOutlineSectionModal(sectionIndex)">
                        <span mwc-icon mwcIconfont="trash-01" style="font-size: 16px;"></span>
                      </button>
                    </div>
                    <div class="outline-section-card__subheading"
                        [class.outline-section-card__subheading--first]="isFirstSubheading"
                        [class.outline-section-card__subheading--last]="isLastSubheading"
                        *ngFor="let subheading of section.subheadings; let subIndex = index; let isFirstSubheading = first; let isLastSubheading = last">
                      <mwc-input-group class="outline-section-card__input-group" [mwcSuffix]="subheadingSuffix">
                        <input mwc-input [(ngModel)]="subheading.header" [ngModelOptions]="{standalone: true}" placeholder="Sub-heading" class="mwc-text-sm-regular">
                      </mwc-input-group>
                      <ng-template #subheadingSuffix><span class="mwc-text-xs-regular mwc-color-gray-400">Sub-Header {{subIndex + 1}}</span></ng-template>
                      <button mwc-button mwcType="text" class="outline-section-card__delete" (click)="openDeleteOutlineSubheadingModal(sectionIndex, subIndex)">
                        <span mwc-icon mwcIconfont="trash-01" style="font-size: 16px;"></span>
                      </button>
                    </div>
                    <a mwc-button mwcType="link-color" class="mwc-text-sm-medium outline-section-card__add-subheading" [class.outline-section-card__add-subheading--has-subheadings]="section.subheadings?.length > 0" (click)="addOutlineSubheading(sectionIndex)">
                      <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>Add Subheading
                    </a>
                  </div>
                  </div>
                </ng-container>

                <app-delete-confirmation
                  [(visible)]="isDeleteOutlineSectionModalVisible"
                  [title]="'Delete &quot;this section&quot;?'"
                  [deleteMessage]="'This will remove this section. This can\'t be undone.'"
                  [confirmButtonText]="'Delete Section'"
                  (confirm)="confirmDeleteOutlineSection()"
                  (cancel)="cancelDeleteOutlineSection()">
                </app-delete-confirmation>

                <app-delete-confirmation
                  [(visible)]="isDeleteOutlineSubheadingModalVisible"
                  [title]="'Delete &quot;this subheading&quot;?'"
                  [deleteMessage]="'This will remove this subheading. This can\'t be undone.'"
                  [confirmButtonText]="'Delete Subheading'"
                  (confirm)="confirmDeleteOutlineSubheading()"
                  (cancel)="cancelDeleteOutlineSubheading()">
                </app-delete-confirmation>
              </div>
            </ng-container>
            <!--Select Templates-->
            <ng-container *ngIf="tab.name == 'Select Templates'">
              <div class="mb-3">
                <div class="mwc-text-lg-medium">{{tab.name}}</div>
                <div class="mwc-text-sm-regular mwc-color-gray-600">
                  Choose multiple templates to create diverse content from this article.
                </div>
              </div>
              <div style="width: 100%;margin: 0 auto 16px 0;" class="d-flex align-items-center justify-content-between">
                <div style="width: 400px;">
                  <mwc-input-group [mwcPrefix]="prefixIconSearchTemplate">
                    <input mwc-input [formControl]="templatesSearchField" type="text" class="mwc-text-sm-regular"
                           [(ngModel)]="searchTxtTemplates" (keyup)="triggerSearchTemplates()"
                           placeholder="Search Template" mwcSize="small" />
                  </mwc-input-group>
                  <ng-template #prefixIconSearchTemplate>
                    <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                  </ng-template>
                </div>
                <div class="d-flex align-items-center gap-3">
                  <span class="mwc-text-sm-medium">Filter by</span>
                  <div>
                    <mwc-select [mwcCustomTemplate]="filterTemplate" [(ngModel)]="filterBy"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="changeFilterBy($event)"
                                [mwcDropdownClassName]="'mwc-xs-select-dropdown'"
                                class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 180px;"
                                [mwcOptionHeightPx]="36">
                      <mwc-option mwcCustomContent mwcLabel="Recommended" mwcValue="recommended">
                        <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                          Recommended <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600"
                                            style="font-size: 18px;" *ngIf="filterBy == 'recommended'"></span>
                        </div>
                      </mwc-option>
                      <mwc-option mwcCustomContent mwcLabel="Recently used" mwcValue="recently-used">
                        <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                          Recently used <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600"
                                              style="font-size: 18px;" *ngIf="filterBy == 'recently-used'"></span>
                        </div>
                      </mwc-option>
                      <mwc-option mwcCustomContent mwcLabel="Alphabetical order " mwcValue="alphabetical-order">
                        <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                          Alphabetical order <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600"
                                                   style="font-size: 18px;" *ngIf="filterBy == 'alphabetical-order'"></span>
                        </div>
                      </mwc-option>
                    </mwc-select>
                    <ng-template #filterTemplate let-selected>
                      {{selected.mwcLabel}}
                    </ng-template>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="!FoundSearchTemplates">
                <div class="empty-screen-branch-voice">
                  <div><img src="../../assets/images/Illustration-search1.svg" /></div>
                  <div>
                    <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Templates found</div>
                  </div>
                </div>
              </ng-container>
              <div class="grid-sec" *ngIf="FoundSearchTemplates">
                <mwc-card *ngFor="let template of filteredTemplatesList; let i = index" class="grid-card"
                          [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;"
                          [ngClass]="template.selected ? 'select-grid':''" (click)="SelectTemplateForGeneration(template)">
                  <div class="template-card-heading">
                    <div class="d-flex align-items-top justify-content-between w-100">
                      <div class="featured-icon {{template.iconColor}}">
                        <span mwc-icon mwcIconfont={{template.icon}}></span>
                      </div>
                      <div>
                        <label mwc-checkbox [mwcSize]="'small'" [mwcChecked]="template.selected"
                               style="pointer-events: none;"></label>
                      </div>
                    </div>
                    <div class="template-card-title mwc-text-md-medium mwc-color-gray-800">{{template.title}}</div>
                  </div>
                  <div class="mwc-text-sm-regular mwc-color-gray-600"> {{template.description}} </div>
                </mwc-card>
              </div>
            </ng-container>
            <!--Select Template-->
            <ng-container *ngIf="tab.name == 'Select Template'">
              <div class="template-sec" *ngIf="!isViewDetails">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div class="mwc-text-lg-medium mwc-color-gray-900">All Workflows</div>
                </div>
                <ng-container *ngIf="noTemplateExist">
                  <div class="empty-screen-branch-voice">
                    <div><img src="../../assets/images/Illustration-search1.svg" /></div>
                    <div>
                      <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Templates found</div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!noTemplateExist">
                  <div class="templates-row" *ngFor="let row of rowedData">
                    <!--<div class="template-card" (click)="onSelect(template)" *ngFor="let template of row">-->
                    <mwc-card *ngFor="let template of row; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;" [ngClass]="(template.isSelected) ? 'select-grid':''">
                      <div class="get-started-overlay">
                        <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedTemplate(template)">
                          <span class="mwc-text-sm-medium">{{( template.isSelected) ? 'Selected' : 'Select'}}</span>
                        </button>
                        <!--<button mwc-button mwcType="primary" mwcSize="small" (click)="generateArticle(false, template)">
                          <span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>
                          <span class="mwc-text-sm-medium">Get Started</span>
                        </button>-->
                        <a mwc-button mwcType="link-color" mwcSize="small" (click)="viewDetailsEvent(template)">
                          <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                          <span class="mwc-text-sm-medium">View Details</span>
                        </a>
                      </div>
                      <mwc-tag *ngIf="template.isRecommended" class="tag" mwcColor="primary">Recommended</mwc-tag>
                      <div class="template-card-heading">
                        <div class="d-flex align-items-top justify-content-between w-100">
                          <div class="featured-icon {{template.iconColor}}">
                            <span mwc-icon mwcIconfont={{template.icon}}></span>
                          </div>
                          <div class="temp-star" *ngIf="template.isFavorite">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                              <g clip-path="url(#clip0_23206_10030)">
                                <path d="M9.87135 1.60996C10.0421 1.19932 10.6239 1.19932 10.7947 1.60996L12.8608 6.57744C12.9328 6.75056 13.0956 6.86885 13.2825 6.88383L18.6453 7.31376C19.0886 7.3493 19.2684 7.90256 18.9306 8.19189L14.8447 11.6919C14.7023 11.8139 14.6401 12.0053 14.6836 12.1876L15.9319 17.4208C16.0351 17.8534 15.5645 18.1954 15.1849 17.9635L10.5936 15.1592C10.4336 15.0615 10.2324 15.0615 10.0724 15.1592L5.48107 17.9635C5.10152 18.1954 4.63089 17.8534 4.73409 17.4208L5.98239 12.1876C6.0259 12.0053 5.96371 11.8139 5.82132 11.6919L1.73542 8.19189C1.39765 7.90256 1.57742 7.3493 2.02074 7.31376L7.38355 6.88383C7.57045 6.86885 7.73325 6.75056 7.80526 6.57744L9.87135 1.60996Z" />
                              </g>
                              <defs>
                                <clipPath id="clip0_23206_10030">
                                  <rect width="20" height="20" fill="white" transform="translate(0.333008)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </div>
                        <div class="template-card-title mwc-text-md-medium mwc-color-gray-800">{{template.title}}</div>
                      </div>
                      <div class="mwc-text-sm-regular mwc-color-gray-600"> {{template.description}} </div>
                    </mwc-card>
                  </div>
                  <!--</div>-->
                </ng-container>
              </div>
              <div *ngIf="isViewDetails">
                <div class="view-details-sec">
                  <div class="d-flex align-items-center justify-content-between" style="border-bottom: 1px solid #EAECF0;padding-bottom: 12px;margin-bottom: 12px;">
                    <div>
                      <a mwc-button mwcType="link-color" mwcSize="small" (click)="viewDetailsBackEvent()">
                        <span mwc-icon mwcIconfont="arrow-left" style="font-size: 16px;"></span>
                        <span class="mwc-text-sm-medium">Back</span>
                      </a>
                    </div>
                    <div>
                      <button mwc-button mwcSize="small" mwcType="default" *ngIf="!viewData.isFavorite" (click)="AddOrRemoveAsFav(viewData.templateId)">
                        <span mwc-icon mwcIconfont="star-01" style="font-size: 16px;"></span>
                        Mark as Favorite
                      </button>
                      <button mwc-button mwcSize="small" mwcType="default" *ngIf="viewData.isFavorite" (click)="AddOrRemoveAsFav(viewData.templateId)">
                        <div class="temp-star">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <g clip-path="url(#clip0_23206_10030)">
                              <path d="M9.87135 1.60996C10.0421 1.19932 10.6239 1.19932 10.7947 1.60996L12.8608 6.57744C12.9328 6.75056 13.0956 6.86885 13.2825 6.88383L18.6453 7.31376C19.0886 7.3493 19.2684 7.90256 18.9306 8.19189L14.8447 11.6919C14.7023 11.8139 14.6401 12.0053 14.6836 12.1876L15.9319 17.4208C16.0351 17.8534 15.5645 18.1954 15.1849 17.9635L10.5936 15.1592C10.4336 15.0615 10.2324 15.0615 10.0724 15.1592L5.48107 17.9635C5.10152 18.1954 4.63089 17.8534 4.73409 17.4208L5.98239 12.1876C6.0259 12.0053 5.96371 11.8139 5.82132 11.6919L1.73542 8.19189C1.39765 7.90256 1.57742 7.3493 2.02074 7.31376L7.38355 6.88383C7.57045 6.86885 7.73325 6.75056 7.80526 6.57744L9.87135 1.60996Z" />
                            </g>
                            <defs>
                              <clipPath id="clip0_23206_10030">
                                <rect width="20" height="20" fill="white" transform="translate(0.333008)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        Remove favorite
                      </button>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="featured-icon {{viewData.iconColor}}">
                        <span mwc-icon mwcIconfont={{viewData.icon}}></span>
                      </div>
                      <div class="template-card-title mwc-text-md-medium mwc-color-gray-800">{{viewData.title}}</div>
                    </div>
                    <div>
                      <button mwc-button mwcSize="small" mwcType="primary" class="mwc-text-sm-medium" (click)="generateArticle(false, viewData)"> Use Template </button>
                    </div>
                  </div>
                  <div mwc-row style="margin-top: 30px;height: calc(100vh - 285px);max-height: 377.2px;overflow: hidden;overflow-y: auto;">
                    <div mwc-col [mwcSpan]="19">
                      <div class="mwc-text-lg-medium mwc-color-gray-700 mb-2">Overview</div>
                      <div class="mwc-text-sm-regular mwc-color-gray-500">{{viewData.summary}}</div>
                      <div class="mwc-text-lg-medium mwc-color-gray-700 mt-3 mb-2">Workflow Advantages</div>
                      <div>
                        <ul style="padding-left: 16px;">
                          <ng-container *ngFor="let whyUseText of viewData.whyUse">
                            <li class="mwc-text-sm-regular mwc-color-gray-500" [innerHTML]="FormattedText(whyUseText)" style="line-height: 22px; margin-bottom: 5px;"></li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                    <div mwc-col [mwcSpan]="5">
                      <div class="mwc-text-md-medium mwc-color-gray-700 mb-2" style="margin-left: 10px !important;">Categories</div>
                      <ul class="p-0 m-0" style="list-style: none;margin-left: 10px !important;">
                        <ng-container *ngFor="let categories of viewData.templateCategories">
                          <li>
                            <mwc-tag [mwcColor]="'gray'" class="d-inline-flex align-items-center gap-1 m-0" style="margin-bottom: 2px !important" [title]="categories">
                              <span mwc-icon mwcIconfont='arrow-up'></span>
                              <span class="categorie-name">{{categories}}</span>
                            </mwc-tag>
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </mwc-tab>
      </ng-container>
    </mwc-tabset>
  </form>
  
    </div>
  </div>

  <div *mwcModalFooter>
    <div mwc-row mwcJustify="end">
      <div mwc-col class="d-flex align-items-center justify-content-between w-100">
        <div>
          <button mwc-button mwcType="default" mwcSize="small" (click)="goBack()" *ngIf="selectedIndex > 0">Back</button>
        </div>
        <div class="d-flex align-items-center gap-3">
          <ng-container *ngIf="!refreshExistingContent && !generateFaqsFromExistingContent && !customTemplates && !youtubeSummaryContent && !bulkMetaGeneration">
            <button mwc-button mwcType="link-color" mwcSize="small" (click)="generateArticle(true)" [disabled]="tabs[selectedIndex]?.name == 'Topic Details' || !(generateAiForm.controls['description'].value?.length > 0) || isRegenerateDisabled" class="mwc-text-sm-semibold" *ngIf="(selectedIndex < (this.tabs.length - 1))">Generate Outline</button>
            <button mwc-button mwcType="primary" mwcSize="small" mwcBlock (click)="processAction()" [disabled]="!(generateAiForm.controls['description'].value?.length > 0) || (tabs[selectedIndex]?.name == 'Topic Details' && (!selectedPrompts?.length || !selectedKeywords?.length))" *ngIf="(selectedIndex < (this.tabs.length - 1))"><span>{{ tabs[selectedIndex + 1]?.name == 'Content Outline' ? 'Review Outline' : 'Continue' }}</span><span mwc-icon mwcIconfont="arrow-right" style="font-size: 16px;"></span></button>
            <button mwc-button mwcType="primary" mwcSize="small" mwcBlock (click)="generateArticle(false)" [disabled]="!(generateAiForm.controls['description'].value?.length > 0) || isRegenerateDisabled || isGeneratingOutline" [mwcLoading]="isLoading" *ngIf="isRegenerateFlow || selectedIndex == tabs.length - 1" class="animation-btn animation-hover-btn" style="height: 36px;overflow: visible;">
              <span  class="inner-text" style="font-size: 14px;">
                <ng-container *ngIf="(isRegenerateFlow && regenerateFlowButtonText == 'Regenerate') || !isRegenerateFlow && !isLoading">
                  <svg class="icon" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" style="width:20px;height:20px">
                    <path stroke-linejoin="round" stroke-linecap="round" stroke="currentColor" d="M14.187 8.096L15 5.25L15.813 8.096C16.0231 8.83114 16.4171 9.50062 16.9577 10.0413C17.4984 10.5819 18.1679 10.9759 18.903 11.186L21.75 12L18.904 12.813C18.1689 13.0231 17.4994 13.4171 16.9587 13.9577C16.4181 14.4984 16.0241 15.1679 15.814 15.903L15 18.75L14.187 15.904C13.9769 15.1689 13.5829 14.4994 13.0423 13.9587C12.5016 13.4181 11.8321 13.0241 11.097 12.814L8.25 12L11.096 11.187C11.8311 10.9769 12.5006 10.5829 13.0413 10.0423C13.5819 9.50162 13.9759 8.83214 14.186 8.097L14.187 8.096Z"></path>
                    <path
                    class="path"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke="currentColor"
                    d="M6 14.25L5.741 15.285C5.59267 15.8785 5.28579 16.4206 4.85319 16.8532C4.42059 17.2858 3.87853 17.5927 3.285 17.741L2.25 18L3.285 18.259C3.87853 18.4073 4.42059 18.7142 4.85319 19.1468C5.28579 19.5794 5.59267 20.1215 5.741 20.715L6 21.75L6.259 20.715C6.40725 20.1216 6.71398 19.5796 7.14639 19.147C7.5788 18.7144 8.12065 18.4075 8.714 18.259L9.75 18L8.714 17.741C8.12065 17.5925 7.5788 17.2856 7.14639 16.853C6.71398 16.4204 6.40725 15.8784 6.259 15.285L6 14.25Z"
                    ></path>
                    <path
                    class="path"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke="currentColor"
                    fill="currentColor"
                    d="M6.5 4L6.303 4.5915C6.24777 4.75718 6.15472 4.90774 6.03123 5.03123C5.90774 5.15472 5.75718 5.24777 5.5915 5.303L5 5.5L5.5915 5.697C5.75718 5.75223 5.90774 5.84528 6.03123 5.96877C6.15472 6.09226 6.24777 6.24282 6.303 6.4085L6.5 7L6.697 6.4085C6.75223 6.24282 6.84528 6.09226 6.96877 5.96877C7.09226 5.84528 7.24282 5.75223 7.4085 5.697L8 5.5L7.4085 5.303C7.24282 5.24777 7.09226 5.15472 6.96877 5.03123C6.84528 4.90774 6.75223 4.75718 6.697 4.5915L6.5 4Z"
                    ></path>
                  </svg>
                </ng-container>
                {{isRegenerateFlow?regenerateFlowButtonText:(selectedIndex == tabs.length - 1 ? 'Generate Blog Post' : 'Generate Now')}}
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="refreshExistingContent || generateFaqsFromExistingContent || customTemplates || youtubeSummaryContent || bulkMetaGeneration">
            <button mwc-button mwcType="primary" mwcSize="small" mwcBlock (click)="processAction()" [disabled]="bulkMetaGeneration ? ( generateAiForm.controls.websiteParentUrl.invalid || generateAiForm.controls.individualUrls.hasError('invalidUrl') || generateAiForm.controls.individualUrls.hasError('multipleDomainsNotAllowed') || generateAiForm.controls.individualUrls.hasError('maxUrlsExceeded')) : ( !hasDescription)" *ngIf="(selectedIndex < (this.tabs.length - 1) && (selectedIndex != 0 || bulkMetaGeneration))"><span>Continue</span><span mwc-icon mwcIconfont="arrow-right" style="font-size: 16px;"></span></button>

          <button mwc-button mwcType="primary" mwcSize="small" mwcBlock (click)="analyzeandProceed()"
            [disabled]="!(!contextUrlControl.pending || (fileList.length> 0) || hasContextText ||
            (generateAiForm.controls['individualUrls']?.value?.length > 0) ||
            (generateAiForm.controls['websiteParentUrl']?.value?.length > 0)) ||
            contentAnalysisStatus=='analyzing' ||
            isContextTextOverLimit ||
            generateAiForm.controls.websiteParentUrl.invalid ||
            generateAiForm.controls.individualUrls.hasError('invalidUrl') ||
            (fileList.length <= 0 &&
            !hasContextText &&
            generateAiForm.controls.contextUrl.invalid &&
            !generateAiForm.controls['individualUrls']?.value?.length &&
            !generateAiForm.controls['websiteParentUrl']?.value?.length)"
            [mwcLoading]="isLoading" *ngIf="selectedIndex == 0 && !bulkMetaGeneration" class="animation-btn animation-hover-btn" style="height: 36px;">
            <span  class="inner-text" style="font-size: 14px;">
              <svg class="icon" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" style="width:20px;height:20px">
                <path stroke-linejoin="round" stroke-linecap="round" stroke="currentColor" d="M14.187 8.096L15 5.25L15.813 8.096C16.0231 8.83114 16.4171 9.50062 16.9577 10.0413C17.4984 10.5819 18.1679 10.9759 18.903 11.186L21.75 12L18.904 12.813C18.1689 13.0231 17.4994 13.4171 16.9587 13.9577C16.4181 14.4984 16.0241 15.1679 15.814 15.903L15 18.75L14.187 15.904C13.9769 15.1689 13.5829 14.4994 13.0423 13.9587C12.5016 13.4181 11.8321 13.0241 11.097 12.814L8.25 12L11.096 11.187C11.8311 10.9769 12.5006 10.5829 13.0413 10.0423C13.5819 9.50162 13.9759 8.83214 14.186 8.097L14.187 8.096Z"></path>
                <path
                class="path"
                stroke-linejoin="round"
                stroke-linecap="round"
                stroke="currentColor"
                d="M6 14.25L5.741 15.285C5.59267 15.8785 5.28579 16.4206 4.85319 16.8532C4.42059 17.2858 3.87853 17.5927 3.285 17.741L2.25 18L3.285 18.259C3.87853 18.4073 4.42059 18.7142 4.85319 19.1468C5.28579 19.5794 5.59267 20.1215 5.741 20.715L6 21.75L6.259 20.715C6.40725 20.1216 6.71398 19.5796 7.14639 19.147C7.5788 18.7144 8.12065 18.4075 8.714 18.259L9.75 18L8.714 17.741C8.12065 17.5925 7.5788 17.2856 7.14639 16.853C6.71398 16.4204 6.40725 15.8784 6.259 15.285L6 14.25Z"
                ></path>
                <path
                class="path"
                stroke-linejoin="round"
                stroke-linecap="round"
                stroke="currentColor"
                fill="currentColor"
                d="M6.5 4L6.303 4.5915C6.24777 4.75718 6.15472 4.90774 6.03123 5.03123C5.90774 5.15472 5.75718 5.24777 5.5915 5.303L5 5.5L5.5915 5.697C5.75718 5.75223 5.90774 5.84528 6.03123 5.96877C6.15472 6.09226 6.24777 6.24282 6.303 6.4085L6.5 7L6.697 6.4085C6.75223 6.24282 6.84528 6.09226 6.96877 5.96877C7.09226 5.84528 7.24282 5.75223 7.4085 5.697L8 5.5L7.4085 5.303C7.24282 5.24777 7.09226 5.15472 6.96877 5.03123C6.84528 4.90774 6.75223 4.75718 6.697 4.5915L6.5 4Z"
                ></path>
              </svg>
              {{bulkMetaGeneration ? 'Analyze':'Analyze and Proceed'}}
            </span>
          </button>
          <button mwc-button mwcType="primary" mwcSize="small" mwcBlock (click)="selectTemplateAndGenerate()" [disabled]="isGenerateDisabled || isRegenerateDisabled" [mwcLoading]="isLoading" *ngIf="selectedIndex != 0" class="animation-btn animation-hover-btn" style="height: 36px;overflow: visible;">
            <span  class="inner-text" style="font-size: 14px;">
              <ng-container *ngIf="(isRegenerateFlow && regenerateFlowButtonText == 'Regenerate') || !isRegenerateFlow">
                <svg class="icon" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" style="width:20px;height:20px" >
                  <path stroke-linejoin="round" stroke-linecap="round" stroke="currentColor" d="M14.187 8.096L15 5.25L15.813 8.096C16.0231 8.83114 16.4171 9.50062 16.9577 10.0413C17.4984 10.5819 18.1679 10.9759 18.903 11.186L21.75 12L18.904 12.813C18.1689 13.0231 17.4994 13.4171 16.9587 13.9577C16.4181 14.4984 16.0241 15.1679 15.814 15.903L15 18.75L14.187 15.904C13.9769 15.1689 13.5829 14.4994 13.0423 13.9587C12.5016 13.4181 11.8321 13.0241 11.097 12.814L8.25 12L11.096 11.187C11.8311 10.9769 12.5006 10.5829 13.0413 10.0423C13.5819 9.50162 13.9759 8.83214 14.186 8.097L14.187 8.096Z"></path>
                  <path
                  class="path"
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  stroke="currentColor"
                  d="M6 14.25L5.741 15.285C5.59267 15.8785 5.28579 16.4206 4.85319 16.8532C4.42059 17.2858 3.87853 17.5927 3.285 17.741L2.25 18L3.285 18.259C3.87853 18.4073 4.42059 18.7142 4.85319 19.1468C5.28579 19.5794 5.59267 20.1215 5.741 20.715L6 21.75L6.259 20.715C6.40725 20.1216 6.71398 19.5796 7.14639 19.147C7.5788 18.7144 8.12065 18.4075 8.714 18.259L9.75 18L8.714 17.741C8.12065 17.5925 7.5788 17.2856 7.14639 16.853C6.71398 16.4204 6.40725 15.8784 6.259 15.285L6 14.25Z"
                  ></path>
                  <path
                  class="path"
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  stroke="currentColor"
                  fill="currentColor"
                  d="M6.5 4L6.303 4.5915C6.24777 4.75718 6.15472 4.90774 6.03123 5.03123C5.90774 5.15472 5.75718 5.24777 5.5915 5.303L5 5.5L5.5915 5.697C5.75718 5.75223 5.90774 5.84528 6.03123 5.96877C6.15472 6.09226 6.24777 6.24282 6.303 6.4085L6.5 7L6.697 6.4085C6.75223 6.24282 6.84528 6.09226 6.96877 5.96877C7.09226 5.84528 7.24282 5.75223 7.4085 5.697L8 5.5L7.4085 5.303C7.24282 5.24777 7.09226 5.15472 6.96877 5.03123C6.84528 4.90774 6.75223 4.75718 6.697 4.5915L6.5 4Z"
                  ></path>
                </svg>
              </ng-container>
              {{isRegenerateFlow?regenerateFlowButtonText:'Generate Now'}}
            </span>
          </button>
        </ng-container>
      </div>
      <!-- <div mwc-col mwcSpan="24" *ngIf="isGenericFlow">
        <button i18n="@@bs-create-new-modal-form-generate-suggestions-button-text" mwc-button mwcType="primary"
          [disabled]="!(generateAiForm.controls['description'].value?.length > 0)" mwcBlock
          (click)="selectYourKeywordModal()" [mwcLoading]="isLoading">Generate Suggestions</button>
      </div> -->
    </div>
  </div>
</div>
<mwc-modal [(mwcVisible)]="isRedirectToMPC" mwcWidth="544px" [mwcCentered]="true" (mwcOnCancel)="redirectToMPCModalCancel()" [mwcFooter]="null">
  <ng-container *mwcModalContent>
    <div mwc-row [mwcGutter]="[16, 32]" style="padding-top: 24px; flex-flow: row;">
      <div mwc-col>
        <div class="mwc-icon-highlight-primary-lg">
          <span mwc-icon mwcIconfont="link-external-02" style="font-size: 20px;"></span>
        </div>
      </div>
      <div mwc-col>
        <ng-container *ngIf="modalType == 'brandVoice'">
          <div class="mwc-text-lg-medium mwc-color-gray-900 mb-2">Manage Brand Voice</div>
          <p class="mwc-text-sm-regular mwc-color-gray-600 m-0">You’ll be redirected to your Business Settings page to update your Brand Voice. After making changes, you can return here to continue.</p>
        </ng-container>
        <ng-container *ngIf="modalType == 'targetAudience'">
          <div class="mwc-text-lg-medium mwc-color-gray-900 mb-2">Manage Target Audience</div>
          <p class="mwc-text-sm-regular mwc-color-gray-600 m-0">You’ll be redirected to your Business Settings page to update your Target Audience. After making changes, you can return here to continue.</p>
        </ng-container>
      </div>
    </div>
    <div style="display: flex;justify-content: right;gap: 16px;" class="p-2 pb-4">
      <button mwc-button mwcType="default" (click)="redirectToMPCModalCancel()" mwcSize="small" class="mwc-text-sm-regular">Cancel</button>
      <button mwc-button mwcType="primary" (click)="redirectToMPCModalOk()" mwcSize="small" class="mwc-text-sm-regular">Continue</button>
    </div>
  </ng-container>
</mwc-modal>

<ng-template #ErrorAlertTemplate>
  <div class="mwc-notification-notice-content">
    <div class="save-notification-body" style="display:flex">
      <span mwc-icon mwcIconfont="alert-circle" style="font-size:20px" class="mwc-color-error-600"></span>
      <div class="mwc-color-error-600 mwc-text-sm-medium " style="margin-right:10px;">{{errorMessage}}</div>
    </div>
  </div>
</ng-template>

<ng-template #customSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

